/**
 * §280G(b)(5) and Vote Room shutdown math — strictly greater than a ratio of eligible shares
 * (matches `VoteTallyService`: floor(eligible × ratio) + 1 approve shares required).
 */

export const DEFAULT_APPROVAL_THRESHOLD_RATIO = 0.75;

export function requiredApproveSharesForThreshold(
  eligibleShares: number,
  ratio: number = DEFAULT_APPROVAL_THRESHOLD_RATIO
): number {
  if (eligibleShares <= 0) return 0;
  return Math.floor(eligibleShares * ratio) + 1;
}

export function isStrictThresholdMet(
  approveShares: number,
  eligibleShares: number,
  ratio: number = DEFAULT_APPROVAL_THRESHOLD_RATIO
): boolean {
  return eligibleShares > 0 && approveShares >= requiredApproveSharesForThreshold(eligibleShares, ratio);
}

/** True when disapprovals/abstentions make reaching the threshold impossible. */
export function isStrictThresholdUnreachable(
  disapproveShares: number,
  abstainShares: number,
  eligibleShares: number,
  ratio: number = DEFAULT_APPROVAL_THRESHOLD_RATIO
): boolean {
  const maxPossibleApprove = eligibleShares - disapproveShares - abstainShares;
  return maxPossibleApprove < requiredApproveSharesForThreshold(eligibleShares, ratio);
}

export function sumSharesByStatus<T extends { shares: number; status?: string | null }>(
  rows: T[],
  status: string
): number {
  return rows.filter((r) => r.status === status).reduce((sum, r) => sum + (Number(r.shares) || 0), 0);
}
